import {
  CANCEL_SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_START,
  CANCEL_SUBSCRIPTION_SUCCESS,
  IS_SUBSCRIBED_TO_FAILURE,
  IS_SUBSCRIBED_TO_START,
  IS_SUBSCRIBED_TO_SUCCESS,
  DELETE_SUBSCRIPTION_PLAN_FAILURE,
  DELETE_SUBSCRIPTION_PLAN_START,
  DELETE_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_PERFORMER_SUBSCRIPTION_PLAN_START,
  FETCH_PERFORMER_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_PERFORMER_SUBSCRIPTION_PLAN_FAILURE,
  FETCH_SUBSCRIPTION_PLAN_FAILURE,
  FETCH_SUBSCRIPTION_PLAN_START,
  FETCH_SUBSCRIPTOIN_PLAN_SUCCESS,
  SUBSCRIBE_TO_PLAN_FAILURE,
  SUBSCRIBE_TO_PLAN_START,
  SUBSCRIBE_TO_PLAN_SUCCESS,
  UPDATE_DEFAULT_SUBSCRIPTION,
  SET_SUBSCRIPTION_FREE_START,
  SET_SUBSCRIPTION_FREE_SUCCESS,
  SET_SUBSCRIPTION_FREE_FAILED,
  TOGGLE_SUBSCRIPTION_FREE,
} from "./ActionConstant";

export function fetchSubscriptionPlanStart() {
  return {
    type: FETCH_SUBSCRIPTION_PLAN_START,
  };
}

export function fetchPerformerSubscriptionPlanStart(data) {
  return {
    type: FETCH_PERFORMER_SUBSCRIPTION_PLAN_START,
    data,
  };
}

export function fetchPerformerSubscriptionPlanSuccess(data) {
  return {
    type: FETCH_PERFORMER_SUBSCRIPTION_PLAN_SUCCESS,
    data,
  };
}

export function fetchPerformerSubscriptionPlanFailture(error) {
  return {
    type: FETCH_PERFORMER_SUBSCRIPTION_PLAN_FAILURE,
    error,
  };
}

export function fetchSubscriptionPlanSuccess(data) {
  return {
    type: FETCH_SUBSCRIPTOIN_PLAN_SUCCESS,
    data,
  };
}

export function fetchSubscriptionPlanFailure(error) {
  return {
    type: FETCH_SUBSCRIPTION_PLAN_FAILURE,
    error,
  };
}

export function updateDefaultSubscription(data) {
  return {
    type: UPDATE_DEFAULT_SUBSCRIPTION,
    data,
  };
}

export function deleteSubscritionPlanStart(data) {
  return {
    type: DELETE_SUBSCRIPTION_PLAN_START,
    data,
  };
}

export function deleteSubscriptionPlanSuccess(data) {
  return {
    type: DELETE_SUBSCRIPTION_PLAN_SUCCESS,
    data,
  };
}

export function deleteSubscriptionPlanFailure(data) {
  return {
    type: DELETE_SUBSCRIPTION_PLAN_FAILURE,
    data,
  };
}

export function subscribeToPlanStart(data) {
  return {
    type: SUBSCRIBE_TO_PLAN_START,
    data,
  };
}

export function subscribeToPlanSuccess(data) {
  return {
    type: SUBSCRIBE_TO_PLAN_SUCCESS,
    data,
  };
}

export function subscribeToPlanFailure(error) {
  return {
    type: SUBSCRIBE_TO_PLAN_FAILURE,
    error,
  };
}

export function isSubscribedToStart(data) {
  return {
    type: IS_SUBSCRIBED_TO_START,
    data,
  };
}

export function isSubscribedToSuccess(data) {
  return {
    type: IS_SUBSCRIBED_TO_SUCCESS,
    data,
  };
}

export function isSubscribedToFailure(error) {
  return {
    type: IS_SUBSCRIBED_TO_FAILURE,
    error,
  };
}

export function cancelSubscriptionStart(data) {
  return {
    type: CANCEL_SUBSCRIPTION_START,
    data,
  };
}

export function cancelSubscriptionSuccess(data) {
  return {
    type: CANCEL_SUBSCRIPTION_SUCCESS,
    data,
  };
}

export function cancelSubscriptionFailure(error) {
  return {
    type: CANCEL_SUBSCRIPTION_FAILURE,
    error,
  };
}

export function setSubscriptionFreeStart(data) {
  return {
    type: SET_SUBSCRIPTION_FREE_START,
    data,
  };
}

export function setSubscriptionFreeSuccess(data) {
  return {
    type: SET_SUBSCRIPTION_FREE_SUCCESS,
    data,
  };
}

export function setSubscriptionFreeFailed(error) {
  return {
    type: SET_SUBSCRIPTION_FREE_FAILED,
    error,
  };
}

export function toggleSubscriptionFree(data) {
  return {
    type: TOGGLE_SUBSCRIPTION_FREE,
    data,
  };
}
